export function SupportSvg({ icon, label }) {
  let iconSize = 'h-5 w-4';
  const iconUrl = icon?.url;

  if (label?.includes('Cart')) {
    iconSize = 'h-5 w-5';
  }

  if (iconUrl) {
    return (
      <div className="flex size-7 items-center justify-center">
        {iconUrl && (
          <div
            className={`group-hover:bg-cozy-cognac mask ${iconSize} bg-black mask-center mask-no-repeat`}
            style={{ maskImage: `url(${iconUrl})` }}
          ></div>
        )}
      </div>
    );
  }
  return label;
}
